import { render, staticRenderFns } from "./SearchContent.vue?vue&type=template&id=6a369ffd"
import script from "./SearchContent.vue?vue&type=script&lang=js"
export * from "./SearchContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports